import { useState } from "react";
import { Users, Bell } from "lucide-react";
import { QRCodeCanvas } from "qrcode.react";
import ClientPushDialog from "@/components/ClientPushDialog";
import { RegeneratePinsButton } from "@/components/settings/RegeneratePins";

export function ClientAppCard({ t, portalUrl, embedded }) {
  const url = (portalUrl && portalUrl.trim()) || ((typeof window !== "undefined" ? window.location.origin : "") + "/klient");
  const [showPush, setShowPush] = useState(false);
  return (
    <div className={embedded ? "" : "bg-slate-800 border border-slate-700 rounded-lg p-4"} data-testid="settings-client-app">
      {!embedded && <h3 className="font-heading font-bold text-sm mb-3 flex items-center gap-2"><Users size={16} className="text-cyan-400" /> {t("Aplikacja klienta (na telefon)")}</h3>}
      <div className="flex flex-col sm:flex-row gap-4 items-center">
        <div className="bg-white p-2 rounded-lg shrink-0"><QRCodeCanvas value={url} size={140} data-testid="client-app-qr" /></div>
        <div className="flex-1 text-sm text-slate-300 space-y-2">
          <p>{t("Klient skanuje ten kod telefonem, aby otworzyć swój panel. Następnie wybiera „Dodaj do ekranu głównego” (Android: menu ⋮, iPhone: Udostępnij), aby zainstalować aplikację i otrzymywać powiadomienia push.")}</p>
          <a href={url} target="_blank" rel="noreferrer" className="text-cyan-400 break-all underline" data-testid="client-app-link">{url}</a>
          <p className="text-[11px] text-slate-500">{t("Logowanie: e-mail + kod PIN. PIN jest pokazywany tylko raz — po wygenerowaniu w karcie klienta.")}</p>
          <RegeneratePinsButton t={t} />
          <button onClick={() => setShowPush(true)} data-testid="client-app-broadcast-push"
            className="w-full sm:w-auto bg-indigo-700 hover:bg-indigo-600 rounded px-3 py-2 text-xs font-medium flex items-center justify-center gap-2 mt-1">
            <Bell size={14} /> {t("Wyślij powiadomienie do wszystkich klientów")}
          </button>
        </div>
      </div>
      <ClientPushDialog open={showPush} onClose={() => setShowPush(false)} clientId={null} clientName="" />
    </div>
  );
}
